import type { FeedingResolution } from '@/domain/feedingDashboard';
import { getIsoWeek, parseDate } from '@/utils/date';

import { formatDashboardDay } from './dashboardDay';

/**
 * A timeline bucket as a caption names it: a day as the period picker prints it, a week as
 * the axis does (W39), so a caption and the bar it describes carry the same label.
 *
 * The week number comes from the same `getIsoWeek` the shared chart layer's axis uses. The
 * key is parsed strictly first, so a key that is not a day is returned as is, as the axis
 * does, rather than printed as W0 or guessed at by moment's lenient fallback.
 */
export function timelineBucketLabel(key: string, resolution: FeedingResolution): string {
    if (resolution === 'day') return formatDashboardDay(key);
    const monday = parseDate(key, 'yyyy-MM-dd');
    return monday ? `W${getIsoWeek(monday)}` : key;
}
